import { Route, Switch } from "react-router-dom";
import { Suspense, lazy } from "react";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/commonComponents/ScrollToTop";
// import HccCodingPage from "./pages/services/HccCodingPage";

const Home = lazy(() => import("./pages/Home"));
const AboutPage = lazy(() => import("./pages/aboutUs/AboutPage"));
const ManagementPage = lazy(() => import("./pages/aboutUs/ManagementPage"));
const InfrastructurePage = lazy(() =>
  import("./pages/aboutUs/InfrastructurePage")
);
const DeliveryPage = lazy(() => import("./pages/aboutUs/DeliveryPage"));
const RevenueCycle = lazy(() => import("./pages/services/RevenueCycle"));
const MedicalCodingServicesPage = lazy(() =>
  import("./pages/services/MedicalCodingServices")
);
const DocumentManagement = lazy(() =>
  import("./pages/services/DocumentManagement")
);
// const PayerServicesPage = lazy(() =>
//   import("./pages/services/PayerServicesPage")
// );
const ContactPage = lazy(() => import("./pages/contact/ContactPage"));
const WorkingWithClarus = lazy(() => import("./pages/careers/WorkingWithClarus"));

function Loader() {
  return (
    <div className="w-full flex justify-center items-center py-16">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#4a675b]"></div>
      <span className="ml-4 text-[#4a675b] font-semibold text-lg">
        Loading...
      </span>
    </div>
  );
}

function App() {
  return (
    <>
      <div className="App">
        <Header />
        <main className="pt-24">
          {" "}
          {/* Add padding-top equal to header height */}
          <Suspense fallback={<Loader />}>
            <ScrollToTop />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/about" component={AboutPage} />
              <Route path="/management" component={ManagementPage} />
              <Route path="/infrastructure" component={InfrastructurePage} />
              <Route path="/delivery" component={DeliveryPage} />
              <Route path="/revenue-cycle" component={RevenueCycle} />
              <Route
                path="/medical-coding"
                component={MedicalCodingServicesPage}
              />
              {/* <Route path="/payer-services" component={PayerServicesPage} /> */}
              {/* <Route path="/hcc-coding" component={HccCodingPage} /> */}
              <Route
                path="/document-management"
                component={DocumentManagement}
              />

              <Route path="/contact" component={ContactPage} />
              <Route path="/working" component={WorkingWithClarus} />
              {/* Add other routes here */}
            </Switch>
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
